export const COLORS = [
	"#1FD9E8",
	"#22B4FF",
	"#1C95D4",
	"#3c5d6e",
	"#6FD474",
	"#59AB5D",
	"#2D7F45",
	"#0E5E38",
	"#FF4500",
	"#E5313E",
	"#CC1121",
	"#8C0927",
	"#FFD238",
	"#FFB625",
	"#F78A18",
	"#E87931",
	"#DD88FF",
	"#B835FF",
	"#A515FF",
	"#7C10BF",
	"#B2BFBF",
	"#96A0A1",
	"#777F7F",
	"#3B4040",
];
